import Base from './base'
import renderFields from './flag-match.pug'

export default class FlagMatch extends Base
  @label: "全域狀態條件"

  renderFields: renderFields
